import messageStore from 'store/message.js'
import authStore from 'store/auth'
import { get } from 'svelte/store';
import { avatarRight, avatarLeft } from "./constant"

export default class Chat {
    constructor(provider){
        this.provider = provider;
        this.loading = false;
        this.responses = {};
    }
    async send(message, option = {}) {
        await this.provider.send(message, option)
    }

    sendMessage(e){
        if ( e.keyCode !== 13 ) {
            return
        }
        const message = e.target.value;
        if (!message) {
            return;
        }
        const { user } =  get(authStore);
        const status = {
            isSending: true,
            isSent: false,
            isFailed: false
        };
        const d = new Date();
        messageStore.set([
            ...get(messageStore).messages, 
            {message, user, status, created_at: d.toISOString()}
        ]);
        this.scrollToCharBottom();
        const messageIndex = get(messageStore).messages.length - 1;
        document.getElementById("message-input-feild").value = ""
        this.responses = status
        this.send(message).then(() => {
            this.responses = {
                ...this.responses,
                isSent: true
            }
        }).catch(() => {
            this.responses = {
                ...this.responses,
                isFailed: true
            }
        })
        .finally(() => {
            this.responses = {
                ...this.responses,
                isSending: false
            };
            const status = this.responses
            messageStore.updateAt(messageIndex, {
                ...get(messageStore).messages[messageIndex],
                status
            });
            this.scrollToCharBottom()
        });
    }

    sendImage(e) {
        const files = e.target.files;
        const allowedExtension = ['image/jpeg', 'image/jpg', 'image/png','image/gif','image/bmp', 'application/pdf'];
        const file = files[0];
        const allowSize = 12; //in mb
        const { type, size } = file;
        
        if ( !allowedExtension.includes(type) || size/(1024*1024) > allowSize ) {
            return;
        }

        this.loading = true;
        this.provider.sendImage(e).then( r => {
            const { file, duration } = r;
            document.getElementById("message-input-feild").value = ""
            const self = this
            const status = {
                isSending: true,
                isSent: false,
                isFailed: false
            };
            this.responses = status
            const message = "file";
            const { user } =  get(authStore);
            const attachments = [{
                type: type.split("/")[0],
                asset_url: file,
                thumb_url: file,
            }];
            const d = new Date();
            messageStore.set([
                ...get(messageStore).messages, 
                {message, attachments, user, status, created_at: d.toISOString()}
            ]);
            const messageIndex = get(messageStore).messages.length - 1;

            this.send(`file`, {attachments}).then(() => {
                self.responses = {
                    ...this.responses,
                    isSent: true
                }
            }).catch(() => {
                self.responses = {
                    ...this.responses,
                    isFailed: true
                }
            })
            .finally(() => {
                this.responses = {
                    ...this.responses,
                    isSending: false
                };
                const status = this.responses
                messageStore.updateAt(messageIndex, {
                    ...get(messageStore).messages[messageIndex],
                    status
                });
            })
        }).finally(() => {
            this.loading = false
        })
    }


    messages() {
        return this.provider.getMessages()
    }

    avatar() {
        return avatarLeft
    }

    myAvatar() {
        const { avatar } = get(authStore);
        if (avatar) return avatar;
        authStore.setAvatar(avatarRight)
        return avatarRight
    }
    
    channels() {
        return this.provider.getChannels()
    }

    async join(data) {
        const channel = await this.provider.joinChannel(data);
        this.scrollToCharBottom();
        return channel;
    }

    async user() {
        return await this.provider.getUser()
    }

    scrollToCharBottom() {
        const chats = document.getElementById("chat-list");
        // chats.scrollTop = chats.scrollHeight;
        chats.scroll({ top: chats.scrollHeight, behavior: 'smooth' });
    }
}